class MapController {

  constructor() {
    this.active = true;

    this.mapElem = document.querySelector('.google-maps');
    this.markerElements = null; 
    this.googleMap = null;
    this.googleMarkers = null;
    this.activeInfoWindow = null;

    this.settings = {
      center: { lat: 53.201655, lng: 5.794899 },
      disableDefaultUI: true,
      zoom: 16
    };

    window.initMap = this.on_init.bind(this);
  }

  on_init() {
    this.define_custommarker();
    this.set_style();
    this.init_googlemap();
  }

  define_custommarker() {
    const self = this;

    this.CustomMarker = class extends google.maps.OverlayView {
      constructor(position, map, content, info) {
        super();
        this.position = position;
        this.map = map;
        this.content = content;
        this.div = null;
        this.info = info; // Store marker info
        this.setMap(map);
      }

      onAdd() {
        const div = document.createElement('div');
        div.style.position = 'absolute';
        div.innerHTML = this.content;
        this.div = div;

        // Add event listener here
        div.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation(); 
          self.onMarkerClick(this.info); // Call MapController's method
        });

        const panes = this.getPanes();
        panes.overlayMouseTarget.appendChild(this.div);
      }

      draw() {
        const overlayProjection = this.getProjection();
        const position = overlayProjection.fromLatLngToDivPixel(this.position);

        if (this.div) {
          this.div.style.left = `${position.x}px`;
          this.div.style.top = `${position.y - 15}px`;
          this.div.style.transform = 'translate(-50%, -100%)';
        }
      }

      onRemove() {
        if (this.div) {
          this.div.parentNode.removeChild(this.div);
          this.div = null;
        }
      }
    };
  }

  set_style() {
    this.settings.styles = window.map_style;
  }

  init_googlemap() {
    if (!this.mapElem) return;

    const markerElements = this.mapElem.querySelectorAll('.marker');
    this.googleMap = new google.maps.Map(this.mapElem, this.settings);
    this.googleMarkers = [];

    const self = this;
    google.maps.event.addListener(this.googleMap, 'click', (event) => {
      self.clearCards();
    });

    markerElements.forEach(markerElem => {
      const info = JSON.parse(markerElem.getAttribute('data-info'));
      const latlng = new google.maps.LatLng(info.lat, info.lng);
      const classes = info.classes;
      const content = `
          <div class="marker theme-${info.color} ${classes.join(' ')}">
            <img src="${info.icon}" alt="icon" />
          </div>`;

      const marker = new this.CustomMarker(latlng, this.googleMap, content, info);

      this.googleMarkers.push(marker);
    });
  }

  // Handle marker click
  onMarkerClick(info) {
    this.clearCards();
    const element = document.createElement('div');
    element.innerHTML = info.card;
    const card = element.children[0];
    document.body.appendChild(card);
    requestAnimationFrame(() => {
        card.style.transform = 'translate(-50%, 0)';
    });
  }

  clearCards() {
    var cards = document.querySelectorAll('.card-project_view-map');
    cards.forEach(card => {
      card.style.transform = 'translate(-50%, 100%)';
      card.addEventListener('transitionend', () => {
        card.parentNode.removeChild(card);
      });
    });
  }
}
